import * as React from "react"
import {Suspense, useState} from "react"
import {useEmployeeNavigationQuery} from "../../../hooks/useEmployeeNavigationQuery";
import Skeleton from "react-loading-skeleton";
import {identity} from "../../../utils/helpers";
import {Button, Container, Modal, Nav, Navbar, NavDropdown, Table} from "react-bootstrap";
import {isDevelopmentBuild} from "../../../utils/constants";
import {ErrorBoundary} from "@sentry/react";

export const EmployeeNavigation = () => {
    const {isInternalUser} = identity();

    if (!isInternalUser && !isDevelopmentBuild) return <></>;

    return (
        <ErrorBoundary fallback={<></>}>
            <Suspense fallback={<Skeleton/>}>
                <Content/>
            </Suspense>
        </ErrorBoundary>
    )
}

const Content = () => {
    const {
        model: {
            id,
            primaryId,
            sku,
            primarySku,
            quantity,
            quantityOnHand,
            targetKeyPhrase,
            reportingClassName,
            environmentalScore,
            rank,
            launchDate,
            status,
            inTransitDays,
            inTransitQuantity,
            isInTransit,
            isAutoOffline,
            isBuiltToOrder,
            isHardMinimumOrder,
            isInStock,
            isNewProduct,
            isOutOfStockNoBackOrder,
            leadIn,
            leadOut,
            frequentlyAskedQuestionHref,
        }
    } = useEmployeeNavigationQuery();

    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    return (
        <>
            <Navbar id="employee-navbar" expand="lg" bg="light" variant="light" className="py-1 d-none d-md-block border-top" fixed="bottom">
                <Container>
                    <Navbar.Brand>D2G Group Employee</Navbar.Brand>
                        <Nav className="me-auto flex-row">
                            <Nav.Link onClick={handleShow} className="me-3">
                                FAQ
                            </Nav.Link>
                            <NavDropdown title={`${(primaryId ? 'Variant' : 'Standalone')} data`} drop='up'>
                                <NavDropdown.Item disabled>
                                    <Table size="sm">
                                        <tbody>
                                        <tr>
                                            <td>Id</td>
                                            <td>{id}</td>
                                        </tr>
                                        {primaryId && (
                                            <tr>
                                                <td>Primary Id</td>
                                                <td>{primaryId}</td>
                                            </tr>
                                        )}
                                        <tr>
                                            <td>SKU</td>
                                            <td>{sku}</td>
                                        </tr>
                                        {primarySku && (
                                            <tr>
                                                <td>Primary SKU</td>
                                                <td>{primarySku}</td>
                                            </tr>
                                        )}
                                        {isInTransit && (
                                            <>
                                                <tr>
                                                    <td>In Transit</td>
                                                    <td>{String(isInTransit)}</td>
                                                </tr>
                                                <tr>
                                                    <td>In Transit Days</td>
                                                    <td>{inTransitDays} days</td>
                                                </tr>
                                                <tr>
                                                    <td>In Transit Quantity</td>
                                                    <td>{inTransitQuantity}</td>
                                                </tr>
                                            </>
                                        )}
                                        <tr>
                                            <td>Quantity On Hand</td>
                                            <td>{quantityOnHand}</td>
                                        </tr>
                                        {isInTransit && (
                                            <tr>
                                                <td>Quantity Available</td>
                                                <td>{quantity}</td>
                                            </tr>
                                        )}
                                        <tr>
                                            <td>Target Key Phrase</td>
                                            <td>{targetKeyPhrase}</td>
                                        </tr>
                                        {reportingClassName && (
                                            <tr>
                                                <td>Reporting Class Name</td>
                                                <td>{reportingClassName}</td>
                                            </tr>
                                        )}
                                        {environmentalScore && (
                                            <tr>
                                                <td>Enkelfahig Score</td>
                                                <td>{environmentalScore}</td>
                                            </tr>
                                        )}
                                        <tr>
                                            <td>Rank</td>
                                            <td>{rank}</td>
                                        </tr>
                                        <tr>
                                            <td>Status</td>
                                            <td>{status}</td>
                                        </tr>
                                        <tr>
                                            <td>Is Auto Offline</td>
                                            <td>{String(isAutoOffline)}</td>
                                        </tr>
                                        <tr>
                                            <td>Built To Order</td>
                                            <td>{String(isBuiltToOrder)}</td>
                                        </tr>
                                        <tr>
                                            <td>Hard Minimum Order</td>
                                            <td>{String(isHardMinimumOrder)}</td>
                                        </tr>
                                        <tr>
                                            <td>In Stock</td>
                                            <td>{String(isInStock)}</td>
                                        </tr>
                                        <tr>
                                            <td>Out Of Stock No Back Order</td>
                                            <td>{String(isOutOfStockNoBackOrder)}</td>
                                        </tr>
                                        <tr>
                                            <td>Launch Date</td>
                                            <td>{launchDate}</td>
                                        </tr>
                                        <tr>
                                            <td>New Product</td>
                                            <td>{String(isNewProduct)}</td>
                                        </tr>
                                        <tr>
                                            <td>Lead In</td>
                                            <td>{leadIn}</td>
                                        </tr>
                                        <tr>
                                            <td>Lead Out</td>
                                            <td>{leadOut}</td>
                                        </tr>
                                        </tbody>
                                    </Table>
                                </NavDropdown.Item>
                            </NavDropdown>
                        </Nav>
                </Container>
            </Navbar>
            <Modal size="lg" centered fullscreen show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>FAQ for {sku}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <iframe src={frequentlyAskedQuestionHref} className="border-0 w-100 h-100"/>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    )
} 